import {
  DIARY_SLOT_SEARCH_REQUEST,
  DIARY_SLOT_SEARCH_SUCCESS,
  DIARY_SLOT_SEARCH_FAIL,
  DIARY_SLOT_CHECK_AVAILABILITY_REQUEST,
  DIARY_SLOT_CHECK_AVAILABILITY_SUCCESS,
  DIARY_SLOT_CHECK_AVAILABILITY_FAIL,
  DIARY_SLOT_BOOK_REQUEST,
  DIARY_SLOT_BOOK_SUCCESS,
  DIARY_SLOT_BOOK_FAIL,
  DIARY_SLOT_UPDATE_REQUEST,
  DIARY_SLOT_UPDATE_SUCCESS,
  DIARY_SLOT_UPDATE_FAIL,
} from "./actionType";

export const searchDiarySlot = (data) => ({
  type: DIARY_SLOT_SEARCH_REQUEST,
  payload: data,
});

export const searchDiarySlotSuccess = (data) => ({
  type: DIARY_SLOT_SEARCH_SUCCESS,
  payload: data,
});

export const searchDiarySlotFail = (error) => ({
  type: DIARY_SLOT_SEARCH_FAIL,
  payload: error,
});

export const checkDiarySlotAvailability = (data) => ({
  type: DIARY_SLOT_CHECK_AVAILABILITY_REQUEST,
  payload: data,
});

export const checkDiarySlotAvailabilitySuccess = (data) => ({
  type: DIARY_SLOT_CHECK_AVAILABILITY_SUCCESS,
  payload: data,
});

export const checkDiarySlotAvailabilityFail = (error) => ({
  type: DIARY_SLOT_CHECK_AVAILABILITY_FAIL,
  payload: error,
});

// Task 24646 - move/reassign a slot. `meta` rides along untouched so the
// board can tell which drag a result belongs to and roll that one back.
export const updateDiarySlot = (data, meta) => ({
  type: DIARY_SLOT_UPDATE_REQUEST,
  payload: data,
  meta,
});

export const updateDiarySlotSuccess = (data, meta) => ({
  type: DIARY_SLOT_UPDATE_SUCCESS,
  payload: data,
  meta,
});

export const updateDiarySlotFail = (error, meta) => ({
  type: DIARY_SLOT_UPDATE_FAIL,
  payload: error,
  meta,
});

export const bookDiarySlot = (data) => ({
  type: DIARY_SLOT_BOOK_REQUEST,
  payload: data,
});

export const bookDiarySlotSuccess = (data) => ({
  type: DIARY_SLOT_BOOK_SUCCESS,
  payload: data,
});

export const bookDiarySlotFail = (error) => ({
  type: DIARY_SLOT_BOOK_FAIL,
  payload: error,
});
